import React from 'react'
import Layout from '../components/Layout'

import { RecipeFieldPreview } from '../cms/components/recipe-field-preview'

export const CollectionPageTemplate = ({ data, headerImage = null }) => {
  const {
    title = '',
    subtitle = '',
    overview = '',
    image = '',
    description = '',
    recipes = [],
  } = data

  return (
    <Layout>
      <section className="hero">
        <img src={image} alt="" />
      </section>

      <section className="hero is-light">
        <div className="hero-body">
          <div className="container">
            <h1 className="title">{title}</h1>
            <h2 className="subtitle">{subtitle}</h2>
          </div>
        </div>
      </section>

      <section className="section section--gradient">
        <div className="container">
          <div className="columns is-multiline">
            <div className="column is-four-fifths">
              <div className="content">
                <p className="has-text-grey-light is-size-3">
                  {overview || 'No Overview'}
                </p>
              </div>
              <div className="content">
                <p>{description || 'No Description'}</p>
              </div>
            </div>
            {recipes
              .filter(v => !!v)
              .map((values, index) => {
                if (!values) {
                  return null
                }
                const {
                  recipe: { id = null, recipe = null },
                } = values

                return <RecipeFieldPreview value={recipe} key={id} />
              })}
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default ({ data: { collection } }) => {
  const recipes = collection.recipes.map(r => ({
    recipe: r,
    id: r.id,
  }))
  return (
    <CollectionPageTemplate
      data={{ ...collection, recipes }}
      headerImage={collection.image}
    />
  )
}

export const query = graphql`
  query CollectionPage($collectionID: String) {
    collection: collectionsJson(id: { eq: $collectionID }) {
      overview
      title
      subtitle
      image
      description
      recipes {
        recipe {
          ingredients {
            name
          }
          image_small
          unit
          servings
          created
          public
          name
          slug
          time
          rating_count
          directions {
            instruction
            image
          }
          temperature
          preparation_time
          finishing_steps {
            name
            steps {
              instruction
              image
            }
          }
          image_medium
          id
          creation_source
          description
          category_id
          image_hero
          average_rating
          creator {
            image_small
            bio
            slug
            last_name
            location
            role
            username
            first_name
            id
            image
            recipe_user_id
          }
          recipe_variants {
            id
            temperature_fahrenheit
            temperature_celsius
            time
            variation_options {
              id
              name
              variation_id
            }
          }
          variations {
            id
            name
            variation_options {
              id
              name
              variation_id
            }
          }
          categories {
            id
            slug
            name
            image
            subtitle
            description
          }
        }
      }
    }
  }
`
